import RightArrow from './Arrow'
import { useMotionTemplate, useMotionValue, motion } from 'framer-motion'
import { useState } from 'react'

const SelectorElement = ({
  icon,
  label,
  onChange,
  active = false,
  disabled = false,
}) => {
  const radius = 100 // change this to increase the rdaius of the hover effect
  const [visible, setVisible] = useState(false)

  let mouseX = useMotionValue(0)
  let mouseY = useMotionValue(0)

  function handleMouseMove({ currentTarget, clientX, clientY }) {
    let { left, top } = currentTarget.getBoundingClientRect()

    mouseX.set(clientX - left)
    mouseY.set(clientY - top)
  }

  return (
    <motion.div
      onClick={(e) => !disabled && onChange(label, e)}
      // className='border border-[#244EF9] w-full rounded-full py-3 px-4 relative'
      style={{
        background: useMotionTemplate`
            radial-gradient(
              ${
                visible ? radius + 'px' : '0px'
              } circle at ${mouseX}px ${mouseY}px,
              var(--blue-500),
              transparent 80%
            )
          `,
      }}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      className='p-[2px] rounded-lg transition duration-300 group/input w-full'
    >
      <div
        className={`
        flex w-full py-3 px-4 relative border-none bg-gray-50 dark:bg-zinc-800 text-black dark:text-white shadow-input rounded-md text-sm  file:border-0 file:bg-transparent 
        file:text-sm file:font-medium placeholder:text-neutral-400 dark:placeholder-text-neutral-600 
        focus-visible:outline-none focus-visible:ring-[2px]  focus-visible:ring-neutral-400 dark:focus-visible:ring-neutral-600
         disabled:cursor-not-allowed disabled:opacity-50
         dark:shadow-[0px_0px_1px_1px_var(--neutral-700)]
         group-hover/input:shadow-none transition duration-400
         ${disabled ? 'cursor-not-allowed text-gray-400' : ''}
        `}
      >
        <div className='w-full flex items-center gap-4'>
          {icon ? <img src={icon} className='w-6 h-6' alt='icon' /> : ''}
          {label}
        </div>
        <div className=''>
          <div
            className={`transition-all ease-in w-12 h-12 rounded-full p-1 absolute -top-[2px] ${
              active ? 'right-[6px] rotate-0' : 'right-[20px] rotate-45'
            }`}
          >
            <div
              className={`border-8 ${
                active ? 'border-[#244EF9]' : 'border-gray-300'
              }  rounded-full w-full h-full`}
            ></div>
          </div>
          {!active ? (
            <>
              {' '}
              <div className='absolute top-0 right-[8px] bottom-0 flex items-center'>
                <RightArrow />
              </div>
              <div className='absolute top-0 right-[2px] bottom-0 flex opacity-60 items-center'>
                <RightArrow />
              </div>{' '}
            </>
          ) : (
            ''
          )}
        </div>
      </div>
    </motion.div>
  )
}

export default SelectorElement
